export default class Helpers {

    // helper function to get sibling of chosen element
    static getSiblings(elem) {
        // Setup siblings array and get the first sibling
        var siblings = [];
        var sibling = elem.parentNode.firstChild;

        // Loop through each sibling and push to the array
        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== elem) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }
        return siblings;
    };

    /**
     * Listen changes on checkbox which toggle hidden area containing required inputs
     */
    static handleCheckboxes() {

        // main toggle function
        const toggleArea = (checkbox, area) => {
            // show/hide area
            if (checkbox.checked) {
                area.classList.remove('none');
            } else {
                area.classList.add('none');
            }
            // based on visibility of area set (un)required inputs
            if (area.classList.contains('none')) {
                handleRequiresInputsInsideArea(area, false);
            } else {
                handleRequiresInputsInsideArea(area, true);
            }
        };

        // check checkboxes on init
        const checkboxes = document.querySelectorAll('.jsCheckbox');
        if (checkboxes.length > 0) {
            checkboxes.forEach( checkbox => {
                let area = document.querySelector(checkbox.dataset.area);
                toggleArea(checkbox, area);
            });
        }
        document.addEventListener('click',function(e){
            if(e.target && e.target.classList.contains('jsCheckbox')){
                let area = document.querySelector(e.target.dataset.area);

                if (area) {
                    // on init
                    toggleArea(e.target, area);
                    // on e.target change
                    e.target.addEventListener('input', () => {
                        toggleArea(e.target, area);
                    });
                }
            }
        });

        /**
         * Set (un)required inputs in toggled area
         * @param area
         * @param state - true to validate nested inputs, false to not validate nested inputs
         */
        function handleRequiresInputsInsideArea(area, state) {
            // mainClass is switch to subClass
            let mainClass = 'data-required';
            let subClass = 'dump-data-required';

            // true = area is visible, we want inputs required
            if (state) {
                mainClass = 'dump-data-required';
                subClass = 'data-required';
                // false = area is hidden, we don't want its required inputs
            } else {
                // form validation is based on checking errors, have to remove them
                const errors = area.querySelectorAll('.form-container--error');

                if (errors.length > 0) {
                    errors.forEach( error => {
                        error.classList.remove('form-container--error');
                    })
                }
            }

            // based on state set requirement by attributes
            let requires = area.querySelectorAll(`[${mainClass}]`);
            if (requires.length > 0) {
                requires.forEach(item => {
                    let value = item.getAttribute(mainClass);
                    item.removeAttribute(mainClass);
                    item.setAttribute(subClass, value);
                });
            }
        }
    }
}
